import PropTypes from 'prop-types';

export const NotificationModel = PropTypes.shape({
  message: PropTypes.string,
  variant: PropTypes.string,
});
